import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, SxProps, TextField } from '@mui/material';
import { useState } from 'react';
import { TraitMap } from "../../types/Types";

import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const ControlsBoxStyles: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    width: '200px',
}

const FormBoxStyles: SxProps = {
    backgroundColor: 'white',
    width: '100px',
    marginTop: '10px',
    marginLeft: '10px'
}

function SelectBox( trait: string, 
    attributeSet: string[] | undefined, 
    filterBoxMap: Map<string, string>,
    setFilterBoxMap: React.Dispatch<React.SetStateAction<Map<string, string>>>): JSX.Element {
    
    const handleChange = (event: SelectChangeEvent) => {
        setFilterBoxMap(map => new Map(map.set(trait, event.target.value as string)))
        // filterBoxMap.set(trait, event.target.value as string);
        // setFilterBoxMap(filterBoxMap);
    };

    const GetSelectValue = (trait: string) => {
        return filterBoxMap.get(trait)
    }

    return (
    <FormControl variant="standard" sx={FormBoxStyles}>
    <InputLabel id={trait}>{trait}</InputLabel>
        <Select
            labelId={trait + "-label"}
            id={trait + "-id"}
            value={GetSelectValue(trait)}
            label={trait}
            onChange={handleChange}
        >
            <MenuItem value={""}>{"Select"}</MenuItem>
            {attributeSet?.map((value) => {
                return <MenuItem value={value}>{value}</MenuItem>
            })}
        </Select>
    </FormControl>
    )
}

const paginationStyle: SxProps = {
    backgroundColor: 'white',
}

function BasicPagination(finalLongneckArrayLength: number, setPage: React.Dispatch<React.SetStateAction<number>>) {
    const handleChange = (value: number) => {
        setPage(value)
    };

    
    return (
      <Stack spacing={2} sx={paginationStyle}>
        <Pagination count={finalLongneckArrayLength} onChange={(event, val) => handleChange(val - 1)}/>
      </Stack>
    );
  }

function FilterBox(traitMap: TraitMap, 
    FilterBoxMap: Map<string, string>, 
    setFilterBoxMap: React.Dispatch<React.SetStateAction<Map<string, string>>>,
    setPage: React.Dispatch<React.SetStateAction<number>>,
    finalLongneckArrayLength: number) {

    // const filterBoxMap = new Map<string, string>();

    // for (let trait of traitMap.keys()) {
    //     console.log(trait);
    //     filterBoxMap.set(trait, "");
    // }

    // const [FilterBoxMap, setFilterBoxMap] = useState<Map<string, string>>(filterBoxMap);
    let Controls: JSX.Element[] = [];
    for (let trait of traitMap.keys()) {
        let attributeSet = traitMap.get(trait);
        Controls.push(
            SelectBox(trait, attributeSet, FilterBoxMap, setFilterBoxMap)
        )
    }
    return (
        <Box sx={ControlsBoxStyles}>
            {Controls}
            {BasicPagination(finalLongneckArrayLength, setPage)}
        </Box>
    )
    
}

export default FilterBox;